import spaceIcon from "../images/icons/spaces.svg";
import projectIcon from "../images/icons/projects.svg";
import appsIcon from "../images/icons/appsIcon.svg";
import insightIcon from "../images/icons/insight.svg";
import analyticsIcon from "../images/icons/analytics.svg";
import sourcesIcon from "../images/icons/sources.svg";
import settingsIcon from "../images/icons/settings.svg";
import logsIcon from "../images/icons/logs.svg";
import launchIcon from "../images/icons/launch.svg";
import filesIcon from "../images/icons/files.svg";
import playgroundIcon from "../images/icons/playground.svg";
import apiIcon from "../images/icons/api.svg";
import deleteIcon from "../images/icons/delete.svg";
import editIcon from "../images/icons/edit.svg";
import trainedIcon from "../images/icons/trained.svg";
import trainingIcon from "../images/icons/training.svg";
import pdfIcon from "../images/icons/pdf.svg";
import docIcon from "../images/icons/doc.svg";
import txtIcon from "../images/icons/txt.svg";
import pptIcon from "../images/icons/ppt.svg";
import resultCorrectIcon from "../images/icons/result_correct.svg";
import resultErrorIcon from "../images/icons/result_error.svg";
import genralSettingsIcon from "../images/icons/settings-2.svg";
import llmIcon from "../images/icons/llm.svg";
import keyIcon from "../images/icons/key.svg";
import thumbupIcon from "../images/icons/thumb_up.svg";
import thumbdownIcon from "../images/icons/thumb_down.svg";
import aiAnalystIcon from "../images/icons/ai_analyst_icon.svg";
import aiQmsIcon from "../images/icons/ai_qms_icon.svg";
import docSearchIcon from "../images/icons/doc_search_icon.svg";
import genrateDashboardIcon from "../images/icons/genrate_dashboard_icon.svg";
import xlsxIcon from "../images/icons/xlsxIcon.svg";
import csvIcon from "../images/icons/csvIcon.svg";
import realmIcon from "../images/icons/realm.svg";
import filterOpenIcon from "../images/icons/Filter-open.svg";
import filterSelectedIcon from "../images/icons/Filter-selected.svg";
import alertIcon from "../images/icons/alert.svg";
import mongoIcon from "../images/icons/mongodb.svg";
import mysqlIcon from "../images/icons/mysql.svg";
import snowflakeIcon from "../images/icons/snowflake.svg";
import fileSourceIcon from "../images/icons/file-source.svg";
import databaseIcon from "../images/icons/database.svg";
import gDriveIcon from "../images/icons/gdrive.svg";
import plugNotConnectedIcon from "../images/icons/plug-notconnected.svg";
import stylingIcon from "../images/icons/styling.svg";
import fileUploadIcon from "../images/icons/file_upload.svg";
import sourceDatabaseIcon from "../images/icons/source_database.svg";
import soucelistIcon from "../images/icons/souce_list.svg";
import authenticationIcon from "../images/icons/authentication.svg";
import defaultsIcon from "../images/icons/defaults.svg";
import embedIcon from "../images/icons/embedd.svg";
import usersettingsIcon from "../images/icons/usersettings.svg";
import rootuserIcon from "../images/icons/rootuser.svg";
import rootauthIcon from "../images/icons/rootauth.svg";
import rootusersettingsIcon from "../images/icons/rootusersettings.svg";
import chatLaunchIcon from "../images/icons/chatLaunch.svg";
import templatesIcons from "../images/icons/templates.svg";
import trashIcon from "../images/icons/trashIcon.svg";
import extractionFilesIcon from "../images/icons/extraction_files.svg";
import connectorsIcon from "../images/icons/connectors.svg";
import documentTypesIcon from "../images/icons/document_types.svg";
import configureIcon from "../images/icons/configureIcon.svg";
import enableIcon from "../images/icons/enableIcon.svg";
import viewIcon from "../images/icons/viewIcon.svg";
import plugIcon from "../images/icons/plugIcon.svg";
import stopwatchIcon from "../images/icons/stopwatchIcon.svg";
import plugConnectedIcon from "../images/icons/plug-connected-Icon.svg";
import azureBlobIcon from "../images/icons/azureBlobIcon.svg";
import awsIcon from "../images/icons/awsIcon.svg";
import mailIcon from "../images/icons/mailIcon.svg";
import driveIcon from "../images/icons/driveIcon.svg";
import errorIcon from "../images/icons/errorIcon.svg";
import progressCheckIcon from "../images/icons/progress-check-icon.svg";
import refreshIcon from "../images/icons/refreshIcon.svg";
import googleIcon from "../images/icons/googleIcon.svg";
import OutlookIcon from "../images/icons/OutlookIcon.svg";
import jsonViewIcon from "../images/icons/jsonViewIcon.svg"
import flagIcon from "../images/icons/flagIcon.svg"
import check2Icon from "../images/icons/circle-check 2.svg"
import check3Icon from "../images/icons/circle-check 3.svg"
import gmailMsgIcon from "../images/icons/gmailMsgIcon.svg"
import extarctionIcon from "../images/icons/extarctionIcon.svg"
import analysisIcon from "../images/icons/analysisIcon.svg"
import office365Icon from "../images/icons/office365Icon.svg";
import userPermissionIcon from "../images/icons/userPermission.svg";
import onedriveIcon from "../images/icons/onedriveIcon.svg";
import ameyaIcon from "../images/icons/ameyaIcon.svg";

import apibotIcon from "../images/icons/apibotIcon.svg";
import dashboardIcon from "../images/icons/dashboardIcon.svg";
import wwwIcon from "../images/icons/wwwIcon.svg";
import textFileIcon from "../images/icons/textFileIcon.svg";
import fastFoodIcon from "../images/icons/fast-food_icon.svg";
import aiAppIcon from "../images/icons/api-app.svg";
import cloudDataIcon from "../images/icons/cloud-data-connection.svg";
import datasetsIcon from "../images/icons/datasetsIcon.svg";
import rootusersIcon from "../images/icons/rootusers.svg";
import aidatasetIcon from "../images/icons/aidataset.svg";
import addIcon from "../images/icons/add.svg";
import paymentIcon from "../images/icons/payment.svg";
import dsupportIcon from "../images/icons/dsupport.svg";
import supportIcon from "../images/icons/support.svg";
import logoutIcon from "../images/icons/logout.svg";
import launchAppIcon from "../images/icons/launchapp.svg";
import chatlaunch1Icon from "../images/icons/chatlaunch-1.svg";
import chatlaunch2Icon from "../images/icons/chatlaunch-2.svg";
import chatlaunch3Icon from "../images/icons/chatlaunch-3.svg";
import chatlaunch4Icon from "../images/icons/chatlaunch-4.svg";
import errorDataIcon from "../images/icons/error_data.svg";
import statusLoadingIcon from "../images/icons/status_loading.svg";
import initStatusIcon from "../images/icons/init_status.svg";

export const IconSvg = {
    spaceIcon,
    projectIcon,
    appsIcon,
    insightIcon,
    analyticsIcon,
    sourcesIcon,
    settingsIcon,
    logsIcon,
    launchIcon,
    filesIcon,
    playgroundIcon,
    apiIcon,
    deleteIcon,
    editIcon,
    trainedIcon,
    trainingIcon,
    pdfIcon,
    docIcon,
    resultCorrectIcon,
    resultErrorIcon,
    genralSettingsIcon,
    llmIcon,
    keyIcon,
    txtIcon,
    pptIcon,
    thumbupIcon,
    thumbdownIcon,
    aiAnalystIcon,
    aiQmsIcon,
    docSearchIcon,
    genrateDashboardIcon,
    xlsxIcon,
    csvIcon,
    realmIcon,
    filterOpenIcon,
    filterSelectedIcon,
    alertIcon,
    mongoIcon,
    mysqlIcon,
    snowflakeIcon,
    fileSourceIcon,
    databaseIcon,
    gDriveIcon,
    plugConnectedIcon,
    plugNotConnectedIcon,
    stylingIcon,
    fileUploadIcon,
    sourceDatabaseIcon,
    soucelistIcon,
    authenticationIcon,
    defaultsIcon,
    embedIcon,
    usersettingsIcon,
    rootuserIcon,
    rootauthIcon,
    rootusersettingsIcon,
    chatLaunchIcon,
    templatesIcons,
    trashIcon,
    extractionFilesIcon,
    connectorsIcon,
    documentTypesIcon,
    viewIcon,
    configureIcon,
    enableIcon,
    plugIcon,
    stopwatchIcon,
    azureBlobIcon,
    awsIcon,
    mailIcon,
    driveIcon,
    errorIcon,
    progressCheckIcon,
    refreshIcon,
    googleIcon,
    OutlookIcon,
    jsonViewIcon,
    flagIcon,
    check2Icon,
    check3Icon,
    gmailMsgIcon,
    extarctionIcon,
    analysisIcon,
    office365Icon,
    userPermissionIcon,
    onedriveIcon,
    ameyaIcon,
    apibotIcon,
    dashboardIcon,
    wwwIcon,
    textFileIcon,
    fastFoodIcon,
    aiAppIcon,
    cloudDataIcon,
    datasetsIcon,
    rootusersIcon,
    aidatasetIcon,
    addIcon,
    paymentIcon,
    dsupportIcon,
    supportIcon,
    logoutIcon,
    launchAppIcon,
    chatlaunch1Icon,
    chatlaunch2Icon,
    chatlaunch3Icon,
    chatlaunch4Icon,
    errorDataIcon,
    statusLoadingIcon,
    initStatusIcon
};